<template>
    <div v-if="flightSurcharge.length && showBlock()"
         :class="['flight-surcharge-block block',{'show': show}]">

        <!--Блок разварачивания-->
        <div @click="blockToggle('flightSurcharge')"
             class="block-toggle-bar align-center justify-between">
            <div class="block-name align-center justify-center">
                <svg width="18px" height="18px" fill="var(--white-color)" fill-opacity="0.7">
                    <use xlink:href="../../../assets/images/sprite.svg#flight"></use>
                </svg>
                <span class="ml-8">{{ flightSurcharge[0].ServiceName }}</span>
            </div>
            <svg width="8px" height="12px" fill="var(--white-color)" class="angle-icon">
                <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
            </svg>
        </div>
        <div v-if="show"
             class="flight-surcharge-info-wrap">
            <div class="flight-surcharge-info">
                <div class="flight-surcharge-group">
                    <div v-for="(item, key) in flightSurcharge"
                         v-show="showItem(item)"
                         :key="key"
                         :style="{'order': getOrder(item)}"
                         class="flight-surcharge-coontent">
                        <div class="date-info">
                            {{item.Code.Value}}
                        </div>
                        <div class="day-info dark-small-bold-text">
                            {{correctDate(item.BeginDateTime)}}
                        </div>
                        <div class="place-info">
                            <div class="dark-small-text">
                                {{item.Details[0].SubCode1.Value}}
                                <span v-show="!item.isChecked">
                                    ({{correctPrice(item.Details[0].Cost, true) +" "+ getCurrencyDisplayBySettings(tourCardData.tourCurrency)}})
                                </span>
                            </div>
                        </div>
                        <div class="flight-surcharge-checkbox">
                            <checkbox v-model="item.isChecked"
                                      @change="checkedFlightSurcharge(item, key)"
                                      :disabled="item.isDisabled"
                                      :class="{'checked': item.isChecked}"
                                      :label="item.isChecked ? localizeList.included : localizeList.notIncluded"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "flight-surcharge",
        props: {
            flightSurcharge: {
                type: Array,
                default: () => []
            },
            tourCardData: {
                type: Object,
                default: () => {}
            },
            show: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            getOrder(item) {
                return !item.IsNotCalculate || !item.IsDeleted ? 1 : 2
            },
            showBlock() {
                return this.flightSurcharge.some(x => !x.isHooded);
            },
            showItem(item) {
                return !item.isHooded
            },
            checkedFlightSurcharge(item, key) {
                this.$emit('checkedFlightSurcharge', [item, key])
            },
            getCurrencyDisplayBySettings(rate){
                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            blockToggle() {
                this.$emit("toggle", !this.show)
            },
            correctDate(date) {
                let correctDate = date.split("T")[0];
                return correctDate.split("-").reverse().join(".");
            },
        }
    }
</script>

<style scoped>
    .block {
        background: var(--white-color);
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
        border-radius: 4px;
        margin-bottom: 12px;
        transition: all .3s;
    }

    .block .block-toggle-bar {
        border-radius: 4px;
        background: var(--primary-color);
        padding: 12px 16px;
        cursor: pointer;
    }

    .block.show .block-toggle-bar {
        border-radius: 4px 4px 0 0;
    }

    .block .block-toggle-bar .block-name span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .block .block-toggle-bar .angle-icon {
        transform: rotate(-90deg);
        transition: all .2s;
    }

    .block.show .block-toggle-bar .angle-icon {
        transform: rotate(90deg);
        transition: all .2s;
    }

    /***FLIGHT SURCHARGE BLOCK***/
    .basket .flight-surcharge-info {
        padding: 16px 28px 20px;
    }

    .basket .flight-surcharge-info .flight-surcharge-group {
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: var(--lighten-2-color);
        border-radius: 6px;
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent {
        display: grid;
        align-items: center;
        grid-template-columns: minmax(200px, auto) auto 1fr auto;
        grid-gap: 18px;
        padding: 12px 16px 12px 12px;
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent:not(:last-child) {
        border-bottom: 1px solid #E0E0E0;
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent /deep/ .flight-surcharge-date.base-select .select {
        background-color: var(--white-color);
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 26px;
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent /deep/ .c-checkbox #c-checkbox {
        color: #717171;
        grid-auto-flow: dense;
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent /deep/ .c-checkbox.checked #c-checkbox {
        color: var(--primary-color);
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent /deep/ .c-checkbox #c-checkbox::before {
        grid-column-start: 2;
    }

    .basket .flight-surcharge-info .flight-surcharge-group .flight-surcharge-coontent /deep/ .c-checkbox #c-checkbox.active::after {
        left: unset;
        right: 4px;
    }

</style>
